var exports = {
  "q3": "blockedContainer__Ox4jPr",
  "cV": "blockedContent__tkiQQ9",
  "Q6": "blockedIcon__JXPwB8",
  "qQ": "blockedText__x8HTe7",
};

module.exports = exports;
